import React, { useEffect, useState } from 'react';
import moment from 'moment';
import classNames from 'classnames';
import mixpanel from 'mixpanel-browser';
import { getSessionId } from '../../analytics/analytics';
import { ensureUser, getPageURL, stringFromLength } from '../../util/data';
import { FormattedMessage } from '../../util/reactIntl';

import SectionMapMaybe from './SectionMapMaybe';
import SectionReviews from './SectionReviews';
import SectionTextMaybe from './SectionTextMaybe';

import { Button, H4, IconProfileCard, Modal, NamedLink, PrimaryButton, ResponsiveImage, SecondaryButton, SocialShare } from '../../components';

import css from './ListingPage.module.css';
import { LISTING_STATE_PUBLISHED } from '../../util/types';
import { findRoleGroup } from './ListingPage.shared';

const SectionCompany = props => {
  const {
    intl,
    config,
    reviews,
    richTitle,
    currentUser,
    currentListing,
    fetchReviewsError,
    isAuthenticated,
    authorListings,
    onUpdateProfile,
    onManageDisableScrolling,
    isOwnListing,
    currentUserListings,
    onSubmitInquiry,
    sendInquiryInProgress,
    chatGPTQuestions,
    downloadLoader,
    onFollowCompany,
    onUpdateFollower,
    followCompany,
    followCompanyInProgress,
    onCancelSendgridSearchEmail,
    setProfileModal
  } = props;
  const showInterestedButton = (currentUserListings && currentUserListings.length && currentUserListings[0] && currentUserListings[0].attributes && currentUserListings[0].attributes.state && currentUserListings[0].attributes.state == LISTING_STATE_PUBLISHED) || false;
  const userListingId = currentUserListings && currentUserListings.length && currentUserListings[0].id;
  const [showMore, setShowMore] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [showInterestModal, setShowInterestModal] = useState(false);
  const { workType: modalWorkType, address: modelAddress, timezone: modalTimezone, roles: modalRoles, responsibilities: modalResponsibilities } = showModal?.attributes?.publicData || {};

  const {
    // description = '',
    geolocation = null,
    publicData = {},
  } = (currentListing.id && currentListing.attributes) || {};
  const {
    // location: listingLocation,
    address,
  } = publicData;

  // const { address = '' } = listingLocation || {};
  const currentAuthor = (currentListing && currentListing.id && currentListing.author) || {};
  const ensuredAuthor = ensureUser(currentAuthor);
  const { bio, publicData: aPublicData } = (ensuredAuthor && ensuredAuthor.id && ensuredAuthor.attributes.profile) || {};
  const { companyFollowing = [], positionInterested = [] } = (currentUser && currentUser.id && currentUser.attributes.profile.publicData) || {};
  const isCompanyFollowed = ensuredAuthor && ensuredAuthor.id && companyFollowing && companyFollowing.length && companyFollowing.includes(ensuredAuthor.id.uuid);
  const isCompany = currentUser && currentUser.id && currentUser.attributes.profile.publicData.accountType === "company";
  // console.log(companyFollowing,'companyFollowing',isCompanyFollowed,ensuredAuthor);
  const fractionalProListingId = (currentUserListings && currentUserListings[0]?.id && currentUserListings[0]?.id?.uuid) || {};

  const isPositionInterested = ensuredAuthor && ensuredAuthor.id && showModal && showModal.id && positionInterested && positionInterested.length && positionInterested.includes(showModal.id.uuid);
  const {
    whyJoin,
    location,
    companyName,
    sizeOfCompany,
    companyIndustry,
    isAdminAccount
  } = aPublicData || {};
  const { address: companyAddress } = location?.selectedPlace || {};
  const { firstName = '', lastName = '' } = (currentUser && currentUser.id && currentUser.attributes && currentUser.attributes.profile) || {};
  const currentUserName = `Hello, ${firstName}`;

  useEffect(() => {
    if (ensuredAuthor?.id?.uuid) {
      mixpanel.track('profile_viewed', {
        page_type: 'company_profile',
        target_id: ensuredAuthor.id.uuid,
        company_name: companyName,
        user_id: currentUser?.id?.uuid || null,
        session_id: getSessionId(),
      });
    }
  }, [ensuredAuthor?.id?.uuid, companyName, currentUser?.id?.uuid]);

  const handleClick = (modalId, userListingId) => {
    mixpanel.track('show_interest_clicked', {
      page_type: 'company_profile',
      target_id: ensuredAuthor?.id?.uuid,
      company_name: companyName,
      position_id: modalId?.uuid,
      user_id: currentUser?.id?.uuid || null,
      session_id: getSessionId(),
    });

    if (!showInterestedButton) {
      setProfileModal(true)
      return;
    };

    const fractionalRoles = currentUserListings?.flatMap(l =>
      l?.attributes?.publicData?.experiences?.map(r => r.label) || []
    ) || [];

    const companyRoles = modalRoles?.map(r => r.label) || [];
    const fractionalGroups = fractionalRoles?.map(findRoleGroup).filter(Boolean);
    const companyGroups = companyRoles?.map(findRoleGroup).filter(Boolean);

    const isMatch = fractionalGroups?.some(fg => companyGroups.includes(fg));
    if (!isMatch) {
      setShowInterestModal(true);
      return;
    }
  
      onUpdateProfile({ positionId: modalId?.uuid, publicData: { searchActivity: true } })
      onSubmitInquiry({ modalId, message: "Hey, I am interested in this Role", userListingId })
      onCancelSendgridSearchEmail(currentUser?.id?.uuid)
    };
  const follower = followCompany?.followers?.find(f => f.companyId === ensuredAuthor?.id?.uuid);

  const handleFollowCompany = () => {
    if (!isCompanyFollowed) {
      onFollowCompany({
        companyId: ensuredAuthor && ensuredAuthor.id && ensuredAuthor.id.uuid,
        fractionalProId: currentUser.id.uuid,
        companyListingId: currentListing?.id?.uuid,
        // fractionalProListingId: 
      })
      onUpdateProfile({ follwerId: ensuredAuthor && ensuredAuthor.id && ensuredAuthor.id.uuid })
    }
    else {

      if (follower?._id) {

        onUpdateFollower(follower._id)
        onUpdateProfile({ follwerId: ensuredAuthor && ensuredAuthor.id && ensuredAuthor.id.uuid })
      }
    }
  }

  return (
    <div className={classNames(css.contentWrapperForProductLayout, css.companyLayout)}>
      <div className={classNames(css.listingGrid, css.companyListingGrid)}>
        <div className={css.leftGird}>
          {currentUser && currentUser.id && isAuthenticated
            ? <div className={css.rotateHeading}>
              <h1>{(currentUserName && currentUserName.length > 17) ? stringFromLength(currentUserName, 15, true) : currentUserName}</h1>
            </div>
            : null}
          <div className={css.companySocialLinksContent}>
            <div className={css.socialLinks}>
              <SocialShare
                isPlain
                url={getPageURL()}
                PageName={'ListingCompanyPage'}
                onClose={() => { }}
                isAuthenticated={isAuthenticated}
                onManageDisableScrolling={onManageDisableScrolling}
                publicData={aPublicData}
                companyId={ensuredAuthor && ensuredAuthor.id && ensuredAuthor.id.uuid}
                companyName={companyName}
              />
              {
                !currentUser?.id?.uuid || isCompany
                  ? null
                  : <PrimaryButton inProgress={followCompanyInProgress}
                  disabled={followCompanyInProgress}
                    className={css.companyFollowBtn}
                    onClick={() => onUpdateProfile({
                      follwerId: ensuredAuthor && ensuredAuthor.id && ensuredAuthor.id.uuid, companyId: ensuredAuthor && ensuredAuthor.id && ensuredAuthor.id.uuid,
                      fractionalProId: currentUser.id.uuid,
                      companyListingId: currentListing?.id?.uuid, alreadyFollowerID: (follower && follower._id) ? follower?._id : null,
                      fractionalProListingId
                    })}>
                    {isCompanyFollowed ? 'Unfollow company' : 'Follow Company'}
                  </PrimaryButton>
              }

            </div>
            {ensuredAuthor.profileImage && ensuredAuthor.profileImage.id
              ? <div className={classNames(css.listingProfileImageBox, !isAuthenticated && css.disableOverlay)}>
                <ResponsiveImage
                  alt='display image'
                  image={ensuredAuthor.profileImage}
                  variants={['default']}
                />
              </div>
              : null}
          </div>

          <div className={css.companyName}>
            {/* <h6>Meet,</h6> */}
            {companyName
              ? <h4> <FormattedMessage id="ListingPage.orderTitle" values={{ title: companyName }} /></h4>
              : null}
          </div>

          {bio
            ? <div className={css.aboutUs}>
              <h5>
                About Us
              </h5>
              {typeof bio == 'string' ? showMore == ('bio') || bio.length <= 287 ? bio : stringFromLength(bio, 284, true) : null}
              {bio && bio.length > 284
                ? <a
                  className={css.showmore}
                  onClick={() => setShowMore(showMore == ('bio') ? false : 'bio')}
                >
                  {showMore == ('bio') ? ' READ LESS' : ' READ MORE'}
                </a>
                : null}
            </div>
            : null}

          <div className={css.mapBox}>
            {(address && geolocation && location?.selectedPlace?.origin?.lat)
              ? <div className={css.mapLocation} id={'mapbox'} >

                <SectionMapMaybe
                  listingId={currentListing.id}
                  geolocation={{
                    "_sdkType": "LatLng",
                    "lat": location?.selectedPlace?.origin?.lat,
                    "lng": location?.selectedPlace?.origin?.lng
                  }
                  }
                  publicData={aPublicData}
                  mapsConfig={config.maps}
                />
              </div>
              : null}
            <div className={css.locationList}>
              {companyAddress && location?.selectedPlace?.address
                ? <div className={css.locationName}>
                  <IconProfileCard type="location" />
                  <span>{location?.selectedPlace?.address}</span>
                </div>
                : null}
              {location?.timezone && <div className={css.locationName}>
                <IconProfileCard type="time" />
                <span>
                  <FormattedMessage id="ListingPage.timeZone" values={{
                    timeZone: location && location.timezone
                      ? moment().tz(location.timezone).format('z') : "NA"
                  }} />
                </span>
              </div>}
            </div>
            <div className={css.moreCompanyInfo}>
              {sizeOfCompany ? <div>
                <b>Company Size:</b>
                <span>{sizeOfCompany}</span>
              </div> : null}
              {(companyIndustry && Array.isArray(companyIndustry) && companyIndustry.length) ? <div>
                <b>Company Industry:</b>
                <span> {companyIndustry && Array.isArray(companyIndustry) && companyIndustry?.map((val, i) => {
                  return val + `${(companyIndustry.length == i + 1) ? '' : ', '}`
                })}</span>
              </div> : null}
              {(companyIndustry && !Array.isArray(companyIndustry) && typeof companyIndustry === 'string' && companyIndustry.length) ? <div>
                <b>Company Industry:</b>
                <span> {companyIndustry}</span>
              </div> : null}
              {(whyJoin && whyJoin.length) ? <div>
                <b><FormattedMessage id="EditListingHowForm.whyJoinUs" /></b>
                <span>{whyJoin}</span>
              </div> : null}
            </div>
          </div>
          {reviews && reviews.length
            ? <SectionReviews
              reviews={reviews}
              fetchReviewsError={fetchReviewsError}
            />
            : null}

        </div>

        {isAdminAccount ? null :
          <div className={classNames(css.rightGrid, css.companyRightGrid)}>
            <h5>Available Positions</h5>

            {authorListings && authorListings.length
              ? authorListings.map((authorListing, i) => {
                const { title, description, price, publicData } = (authorListing && authorListing.id && authorListing.attributes) || {};
                const { roles = [], start, workType } = publicData || {};
                const boardMember = (roles && roles.length && Array.isArray(roles) && roles[0]?.boardMember) || false;

                return (<div className={css.positions} key={title + '-' + i}>
                  <div className={css.cardTop}>
                    {Array.isArray(currentListing.images)
                      ? <div className={classNames(css.positionsImage)}>
                        <ResponsiveImage
                          alt='display image'
                          image={ensuredAuthor.profileImage}
                          variants={['default']}
                        />
                      </div>
                      : null}
                    <div>
                      <h4>{title}</h4>
                      <ul>
                        {(roles && roles?.length && roles[0] && roles[0]?.perHourRate && roles?.[0]?.perHourRate?.label) ? (
                          <p className={css.hourlyRate}>
                            {(() => {
                              const label = roles[0]?.perHourRate?.label; // "CA$150-200"
                              const suffix = boardMember ? 'per month' : 'per hour';

                              const [min, max] = label?.replace('CA$', '').split('-') || [];

                              return `CAD $${min} - $${max} ${suffix}`;
                            })()}
                          </p>
                        ) : (price && price?.amount) ? (
                          <p className={css.hourlyRate}>
                            {`CAD $${price?.amount / 100} ${boardMember ? 'per month' : 'per hour'}`}
                          </p>
                        ) : null}

                        {(roles && roles?.length && roles[0] && roles[0]?.perHourRate && roles[0]?.perHourRate?.label) ? (
                          <li>
                            {roles?.[0]?.availableHoursPerWeek?.label}{' '}
                            {roles?.[0]?.rateType === 'perMonth'
                              ? 'Monthly'
                              : boardMember
                                ? 'Monthly'
                                : 'Weekly'}
                          </li>
                        ) : null}

                        {roles && roles?.length ? <li>Start  {roles[0]?.startDate ? new Date(roles[0]?.startDate?.date).toLocaleDateString() : roles[0]?.start}</li> : null}
                        {workType ? <li>{workType == 'flexible' ? "Flexible to anything" : workType.charAt(0).toUpperCase() + workType.slice(1)}</li> : null}

                      </ul>
                    </div>
                  </div>
                  <div className={css.cardBottom}>
                    <p>{description && description.length > 122 ? stringFromLength(description, 119, true) : description}
                      ...<span className={css.seeDetailsBtn} onClick={() => setShowModal(authorListing)}>
                        See Details
                      </span>
                    </p>
                  </div>
                </div>)
              })
              : null}
          </div>
        }
      </div>

      <Modal
        id="ListingPage.SeAllModal"
        isOpen={!!showModal}
        onClose={() => setShowModal(false)}
        onManageDisableScrolling={onManageDisableScrolling}
        className={css.jobmodalDetails}
        type={'MultiPurposeModal'}
      >
        {showModal && showModal.id
          ? <div className={css.jobModalContent}>
            <h3 className={css.modalTitle}>{showModal?.attributes?.title}
            </h3>
            <p className={css.companyName}>{companyName}</p>
            <ul>
              <li className={css.jobFactsContainer}>
                <span className={css.jobFactList} >{modalWorkType == 'flexible' ? "Flexible to anything" : modalWorkType?.charAt(0)?.toUpperCase() + modalWorkType?.slice(1)} | {modalWorkType !== "remote" && `${modelAddress} |`}  {moment()?.tz(modalWorkType === "remote" ? location?.timezone : modalTimezone)?.format('z')}</span>
                <span className={css.jobFactList} >{modalRoles?.[0]?.availableHoursPerWeek?.label} {modalRoles && modalRoles?.length > 0 && modalRoles?.[0]?.rateType == 'perMonth'? 'Monthly' : 'Weekly'}</span>
                {modalRoles && modalRoles?.length > 0 && modalRoles[0]?.openHiring && modalRoles[0]?.openHiring == 'yes' && <span className={css.jobFactList} >Open to fractional salaried position</span>}

                {modalRoles && modalRoles?.length > 0 && modalRoles[0]?.bonus && modalRoles[0]?.bonus == 'yes' && <span className={css.jobFactList} >Potential for Bonuses</span>}
              </li>
            </ul>

            <h5 className={css.modalSectionTitle}>The Role</h5>
            <p className={css.jobDescription}>{showModal?.attributes?.description}</p>

            {modalRoles && Array.isArray(modalRoles) && modalRoles?.map((role, index) => (
              <div key={index}>
                {[
                  { title: 'Skills', data: role?.skills },
                  {
                    title: 'Specialties', data: (role && role.
                      specialties && role.
                        specialties.length) ? role?.
                      specialties : (role && role.specialtiesArray && role.specialtiesArray.length
                      ) ? role.specialtiesArray : []
                  },
                  {
                    title: 'Tech Tools', data: (role && role.favouriteTool && role.favouriteTool.length) ? role?.favouriteTool : (role && role.favouriteToolArray && role.favouriteToolArray.length
                    ) ? role.favouriteToolArray : []
                  },
                ].map(({ title, data }, sectionIndex) =>
                  Array.isArray(data) && data.length > 0 ? (
                    <div key={sectionIndex}>
                      <h5 className={css.modalSectionTitle}>{title}</h5>
                      <ul className={css.companiesList}>
                        {data.map((item, itemIndex) => (
                          <li key={itemIndex}>
                            <span>{(item && item.label) ? item?.label : item}</span>
                          </li>
                        ))}
                      </ul>
                    </div>
                  ) : null
                )}
              </div>
            ))}
            <br />
            {isOwnListing ?
              <PrimaryButton
                type="button"
                className={css.secondaryBtn}
                onClick={(e) => {
                  e.preventDefault();
                  chatGPTQuestions(showModal, () => {
                    setShowModal(false);
                  });
                }}
                inProgress={downloadLoader}
                disabled={downloadLoader}
              >
                Interview Questions
              </PrimaryButton> : null}

            {isOwnListing ? <Button
              className={css.buttonInterested}><NamedLink name="AlgoliaSearchPage" className={css.buttonInterested}>
                Discover Talent

              </NamedLink></Button> : <Button
                className={css.buttonInterested}
                onClick={() => { handleClick(showModal?.id, userListingId) }}
                disabled={sendInquiryInProgress}
                inProgress={sendInquiryInProgress}
              >
              Show interest
            </Button>
            }

            {isOwnListing ? <Button
              className={css.buttonInterested}><NamedLink
                className={css.buttonInterested}
                name="MatchedListingsPage"
                params={{ id: showModal?.id?.uuid }}>
                View Matched Listings
              </NamedLink></Button>
              : null
            }
          </div>
          : null}
      </Modal>

      {/* fractional express interest modal  */}
      <Modal
        id="ListingPage.FractionalInterest"
        isOpen={!!showInterestModal}
        onClose={() => setShowInterestModal(false)}
        usePortal
        onManageDisableScrolling={onManageDisableScrolling}
        className={css.showInterestModal}
      >
        You cannot express interest in a role out of your scope of expertise. Please try again for a role related to your experience
      </Modal>
    </div>
  );
};

export default SectionCompany; 